<template>
	<div class="card-list">
		<div v-if="data.length" ref="content" class="card-list-content" :style="{ overflow }">
			<div
				class="card-list-content-item"
				v-for="(item, index) in data"
				:key="item[rowKey] || index"
				:class="customItemClass"
				:style="{ 'min-width': minWidth }"
			>
				<slot :item="item" :index="index"></slot>

				<slot name="footer-btn" :item="item" :index="index"></slot>
			</div>
		</div>

		<div v-else class="card-list-empty">
			<img src="@/assets/icons/common/empty.svg" />
			<span>{{ $t("emptyData") }}</span>
		</div>
		<div class="card-list-pagination" v-if="pagination.total > (paginationConfig.minSize || 12)">
			<el-pagination
				:background="'background' in paginationConfig ? paginationConfig.background : true"
				:layout="'layout' in paginationConfig ? paginationConfig.layout : 'sizes, total, prev, pager, next, jumper'"
				:total="pagination.total"
				:page-sizes="paginationConfig.pageSizes || [12, 24, 36]"
				:page-size="pagination.limit"
				:current-page="pagination.page"
				@current-change="currentChange"
				@size-change="sizeChange"
				v-bind="paginationConfig"
				v-on="$listeners"
			/>
		</div>
	</div>
</template>

<script>
/**
 * 卡片列表组件
 * @param {Array} data - 卡片列表数据
 * @param {Object} pagination - 分页页码数据
 * @param {String} customItemClass - 自定义卡片class
 * @param {String} minWidth - 卡片最小宽度
 * @param {String} overflow - 卡片列表滚动
 * @param {Object} paginationConfig - 分页配置
 * @param {Number} paginationConfig.minSize - 最小显示数量, 默认12, 小于该数量不显示分页
 * @param {String} rowKey - 卡片列表数据的唯一标识，默认为id，不存在时使用索引
 *
 * @event pagination-change - 分页改变，返回当前分页页码数据
 */
export default {
	name: "CardList",
	props: {
		/**
		 * 卡片列表数据
		 */
		data: {
			type: Array,
			required: true,
			default: () => []
		},
		/**
		 * 分页页码数据
		 */
		pagination: {
			type: Object,
			default: () => ({
				total: 0,
				limit: 12,
				page: 1
			})
		},
		/**
		 * 自定义卡片class
		 */
		customItemClass: {
			type: String
		},
		/**
		 * 卡片最小宽度
		 */
		minWidth: {
			type: String,
			default: "24%"
		},
		/**
		 * 卡片列表滚动
		 */
		overflow: {
			type: String,
			default: "auto"
		},
		/**
		 * 分页配置
		 */
		paginationConfig: {
			type: Object,
			default: () => ({})
		},
		rowKey: {
			type: String,
			default: "id"
		}
	},
	methods: {
		// 分页改变
		currentChange(page) {
			const currentPagination = {
				...this.pagination,
				page
			};

			this.$emit("update:pagination", currentPagination);
			this.$emit("pagination-change", currentPagination);
		},
		sizeChange(size) {
			const currentPagination = {
				...this.pagination,
				page: 1,
				limit: size
			};

			this.$emit("update:pagination", currentPagination);
			this.$emit("pagination-change", currentPagination);
		}
	},
	watch: {
		data: {
			handler() {
				// 每次数据更新后自动滚动到顶部
				this.$nextTick(() => {
					this.$refs.content && this.$refs.content.scrollTo(0, 0);
				});
			},
			deep: true
		}
	}
};
</script>

<style scoped lang="scss">
.card-list {
	width: 100%;
	display: flex;
	flex-direction: column;
	box-sizing: border-box;

	&-content {
		flex: 1;
		display: grid;
		grid-row-gap: 12px;
		grid-column-gap: 12px;
		grid-template-columns: repeat(auto-fill, minmax(392px, 1fr));
		align-content: start;

		&-item {
			box-sizing: border-box;
			background: #fff;
			border: 1px solid #e8ebf2;
			border-radius: 4px;

			&:hover {
				box-shadow:
					0 5px 5px -3px #3c424d1a,
					0 8px 10px 1px #3c424d0f,
					0 3px 14px 2px #3c424d0d;
			}
		}
	}

	&-empty {
		flex: 1;
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		height: 20px;
		font-size: 14px;
		font-family: PingFangSC, PingFangSC-Regular;
		font-weight: 400;
		text-align: center;
		color: #999999;
		line-height: 20px;

		> img {
			width: 120px;
			height: 120px;
		}
	}

	&-pagination {
		display: flex;
		background: #fff;
		padding: 12px 16px;
		flex-direction: column;
		justify-content: center;
		align-items: flex-end;
		margin-top: 12px;
		::v-deep .btn-prev {
			background-color: transparent;
			color: #abb0ba;
		}
		::v-deep .btn-next {
			background-color: transparent;
			color: #abb0ba;
		}
		::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
			color: #095ce6;
			background-color: #f2f3ff;
		}
	}
}
</style>
